export function debounce<TArgs extends readonly unknown[]>(
  fn: (...args: TArgs) => unknown,
  ms: number,
): (...args: TArgs) => void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  return (...args: TArgs) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, ms);
  };
}

export function throttle<TArgs extends readonly unknown[]>(
  fn: (...args: TArgs) => unknown,
  ms: number,
): (...args: TArgs) => void {
  let last = 0;
  return (...args: TArgs) => {
    const now = Date.now();
    if (now - last >= ms) {
      last = now;
      fn(...args);
    }
  };
}
